<div class="section-box" *ngIf="(keywords | async)?.length > 0">
  <div class="keyword-list" #keywordDefinitionReference>
    <div
      *ngFor="let keyword of keywords | async; trackBy: trackByKeyWord"
      class="keyword-container"
      [id]="keyword.id"
      (click)="onSelectKeyword(keyword)"
      (keyup)="onSelectKeyword(keyword)"
    >
      <p class="keyword-label">
        {{ 'APP.KEYWORDS_DEFINITION.KEYWORD' | translate }}
      </p>
      <div class="chevrons">
        <span [innerHTML]="keyword.keyTerm | safeHtml"></span>
        <span
          *ngIf="
            keyword?.altLabelsCount > 2 ||
            (keyword?.altLabelsCount === 2 && chkForChevrons(keyword))
          "
          class="references-traversal chevrons-{{ keyword.id }}"
        >
          <span
            class="left-arrow wk-icon-chevron-left"
            title="{{ 'APP.KEYWORDS_DEFINITION.CHEVRON_LEFT' | translate }}"
            (click)="toggleChevronNav(keyword, 'left')"
            (keyup)="toggleChevronNav(keyword, 'left')"
          ></span>
          <span title="divider" class="line"></span>
          <span
            class="right-arrow wk-icon-chevron-right"
            title="{{ 'APP.KEYWORDS_DEFINITION.CHEVRON_RIGHT' | translate }}"
            (click)="toggleChevronNav(keyword, 'right')"
            (keyup)="toggleChevronNav(keyword, 'right')"
          ></span>
        </span>
      </div>
      <p class="keyword-label">
        {{ 'APP.KEYWORDS_DEFINITION.DEFINITION' | translate }}
      </p>
      <div
        class="keyword-definition"
        [innerHTML]="keyword.definition | safeHtml"
        (click)="onDefinitionClick($event)"
        (keyup)="onDefinitionClick($event)"
      ></div>
      <div class="action-icons">
        <span [ngClass]="{ 'hide-action-icons': !showKeywordActionIcons }">
          <span
            title="{{ 'APP.KEYWORDS_DEFINITION.EDIT_KEYWORD' | translate }}"
            class="wk-icon-pencil"
            (click)="onEditKeyword($event, keyword)"
            (keyup)="onEditKeyword($event, keyword)"
          ></span>
          <span
            title="{{ 'APP.KEYWORDS_DEFINITION.COPY_KEYWORD' | translate }}"
            class="wk-icon-files"
            (click)="onCopyKeyword($event, keyword)"
            (keyup)="onCopyKeyword($event, keyword)"
          ></span>
          <span
            title="{{ 'APP.KEYWORDS_DEFINITION.DELETE_KEYWORD' | translate }}"
            class="wk-icon-trash"
            (click)="onDeleteKeyword($event, keyword)"
            (keyup)="onDeleteKeyword($event, keyword)"
          ></span>
        </span>
      </div>
    </div>
  </div>
</div>
